import { render, staticRenderFns } from "./WangEditor.vue?vue&type=template&id=5c32d93d&scoped=true&lang=html&"
import script from "./WangEditor.vue?vue&type=script&lang=js&"
export * from "./WangEditor.vue?vue&type=script&lang=js&"
import style0 from "./WangEditor.vue?vue&type=style&index=0&id=5c32d93d&lang=less&scoped=true&"
import style1 from "./WangEditor.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c32d93d",
  null
  
)

export default component.exports